// Module
var code = "<template> <require from=\"app/cm/components/household/current-case-statuses-grid\"></require> <current-case-statuses-grid household-case-id.bind=\"householdCaseId\"></current-case-statuses-grid> </template> ";
// Exports
module.exports = code;